export default __webpack_public_path__ + "d952e50f42c430558ff892464a9bd80f.svg";